import axios from 'axios'
import globalVar from './GlobalVar.js'
// const apiClient = axios.create({
//   //baseURL: 'https://postchat.us/api/',
//   baseURL: 'https://pctest.mpos.us/api/', //test
//   //baseURL: 'http://localhost:56910/api/',
//   //baseURL: 'http://192.168.0.5:56910/api/',
//   withCredentials: false,
//   headers: {
//     'Content-Type': 'application/json'
//   }
// })

export default {
  request(url, parameter) {
    let para = JSON.stringify(parameter)

    // if (sessionStorage.getItem('configData')) {
    //   const value = JSON.parse(sessionStorage.getItem('configData'))
    //   //console.log('config Data: ', value)

    //   const apiClient = axios.create({
    //     baseURL: value.baseURLToken,
    //     withCredentials: false,
    //     //transformRequest: [data => JSON.stringify(data.data)],
    //     headers: {
    //       'Content-Type': 'application/json'
    //     }
    //   })
    //   //apiClient.baseURL = value.baseURL
    //   return apiClient.post(url, para)
    // }

    var apiClient
    if (globalVar.mode == 'normal') {
      if (globalVar.state == 'test') {
        apiClient = axios.create({
          baseURL: 'https://pctest.mpos.us/api/',
          withCredentials: false,
          //transformRequest: [data => JSON.stringify(data.data)],
          headers: {
            'Content-Type': 'application/json'
          }
        })
      } else if (globalVar.state == 'live') {
        apiClient = axios.create({
          baseURL: 'https://postchat.us/api/',
          withCredentials: false,
          //transformRequest: [data => JSON.stringify(data.data)],
          headers: {
            'Content-Type': 'application/json'
          }
        })
      }
    } else if (globalVar.mode == 'lite') {
      if (globalVar.state == 'test') {
        apiClient = axios.create({
          baseURL: 'https://testapi.mpos.us/api/',
          withCredentials: false,
          //transformRequest: [data => JSON.stringify(data.data)],
          headers: {
            'Content-Type': 'application/json'
          }
        })
      } else if (globalVar.state == 'live') {
        apiClient = axios.create({
          baseURL: 'https://orderapi.mpos.us/api/',
          withCredentials: false,
          //transformRequest: [data => JSON.stringify(data.data)],
          headers: {
            'Content-Type': 'application/json'
          }
        })
      }
    }
    //apiClient.baseURL = value.baseURL
    return apiClient.post(url, para)
  },

  multipart(url, parameter, fileList) {
    let formData = new FormData()
    let para = JSON.stringify(parameter)
    formData.append('JsonData', para)
    for (var i = 0; i < fileList.length; i++) {
      formData.append('File', fileList[i].file)
    }

    // if (sessionStorage.getItem('configData')) {
    //   const value = JSON.parse(sessionStorage.getItem('configData'))
    //   //console.log('config Data: ', value)

    //   const apiClient = axios.create({
    //     baseURL: value.baseURLToken,
    //     withCredentials: false,
    //     //transformRequest: [data => JSON.stringify(data.data)],
    //     headers: {
    //       'Content-Type': 'multipart/form-data'
    //     }
    //   })
    //   //apiClient.baseURL = value.baseURL
    //   return apiClient.post(url, formData, {
    //     headers: {
    //       'Content-Type': 'multipart/form-data'
    //     }
    //   })
    // }

    var apiClient
    if (globalVar.mode == 'normal') {
      if (globalVar.state == 'test') {
        apiClient = axios.create({
          baseURL: 'https://pctest.mpos.us/api/',
          withCredentials: false,
          //transformRequest: [data => JSON.stringify(data.data)],
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      } else if (globalVar.state == 'live') {
        apiClient = axios.create({
          baseURL: 'https://postchat.us/api/',
          withCredentials: false,
          //transformRequest: [data => JSON.stringify(data.data)],
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      }
    } else if (globalVar.mode == 'lite') {
      if (globalVar.state == 'test') {
        apiClient = axios.create({
          baseURL: 'https://testapi.mpos.us/api/',
          withCredentials: false,
          //transformRequest: [data => JSON.stringify(data.data)],
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      } else if (globalVar.state == 'live') {
        apiClient = axios.create({
          baseURL: 'https://orderapi.mpos.us/api/',
          withCredentials: false,
          //transformRequest: [data => JSON.stringify(data.data)],
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      }
    }
    //apiClient.baseURL = value.baseURL
    return apiClient.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}
